var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer py-3"},[_c('div',{staticClass:"container-fluid text-center"},[_vm._v(" © 2021 - NIXAP DEVELOPMENT S.R.L. ")])])}]

export { render, staticRenderFns }